module.exports = __webpack_public_path__ + "static/media/step1.f5bc7e5d.png";